import React from 'react'
import { motion } from 'framer-motion'
import Swal from 'sweetalert2'
import biomed from '../../assets/biomed.jpeg'

    const handleGetinTouch = () => {
        Swal.fire({
        html: `
            <div style="display: flex; flex-direction: column; gap: 16px; padding: 8px 0;">
                <a href="tel:+233303955917" style="display: flex; align-items: center; justify-content: center; gap: 10px; padding: 16px 24px; background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%); color: white; border-radius: 12px; text-decoration: none; font-weight: 700; font-size: 16px; box-shadow: 0 4px 12px rgba(2, 132, 199, 0.4); transition: all 0.3s ease; border: none;">
                    <span style="font-size: 20px;">📞</span>
                    <span>Call: 0303955917</span>
                </a>
                <a href="mailto:info@alivanymedicalsupplies.com" style="display: flex; align-items: center; justify-content: center; gap: 10px; padding: 16px 24px; background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%); color: white; border-radius: 12px; text-decoration: none; font-weight: 700; font-size: 16px; box-shadow: 0 4px 12px rgba(13, 148, 136, 0.4); transition: all 0.3s ease; border: none;">
                    <span style="font-size: 20px;">✉️</span>
                    <span>Email: info@alivanymedicalsupplies.com</span>
                </a>
            </div>
        `,
        title: 'Get in Touch',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: '×',
        cancelButtonColor: 'transparent',
        background: '#f8fafc',
        backdrop: 'rgba(0, 0, 0, 0.5)',
            customClass: {
            popup: 'rounded-2xl border-2 border-medical-blue-200 shadow-2xl relative',
            title: 'text-2xl font-bold text-medical-blue-700 mb-6',
            htmlContainer: 'text-center pb-2',
            cancelButton: '!absolute !top-3 !right-3 !w-10 !h-10 !rounded-full !bg-gray-100 hover:!bg-gray-200 !text-gray-700 !font-bold !text-2xl !flex !items-center !justify-center !transition-all !m-0 !p-0 !border-none !shadow-md hover:!shadow-lg',
        },
        width: '400px',
        buttonsStyling: false,
        })
    }

export default function Card6() {
    const description = `Our team of experienced biomedical engineers uses cutting-edge technology and scientific principles to develop innovative solutions that meet the specific needs of our clients. We provide a range of services, including feasibility studies, product development, testing, regulatory compliance, and manufacturing. Our services cover a range of areas, including medical imaging, clinical engineering, and medical device design. We also offer consulting services to help our clients navigate complex regulatory environments and ensure that their products meet industry standards.
            
We are committed to providing our clients with the highest quality services, delivered in a timely and cost-effective manner. We pride ourselves on our ability to work closely with our clients to understand their unique needs and to develop customized solutions that meet those needs. With our expertise in biomedical engineering and our commitment to quality, we are confident that we can help our clients achieve their goals and improve the quality of healthcare delivery.`

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="max-w-5xl mx-auto"
        >
            <div className="bg-white rounded-2xl overflow-hidden border-3 border-gray-300 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05),0_0_0_1px_rgba(59,130,246,0.1),0_0_20px_rgba(2,132,199,0.2)] hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04),0_0_0_1px_rgba(59,130,246,0.2),0_0_30px_rgba(2,132,199,0.3)] transition-all duration-300" style={{ borderWidth: '3px' }}>
                {/* Image Section */}
                <div className="relative h-80 md:h-96 overflow-hidden bg-gradient-to-br from-medical-blue-50 via-medical-teal-50 to-medical-green-50">
                    <img
                        src={biomed}
                        alt="Biomedical Engineering Services"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-medical-blue-900/70 via-medical-blue-800/40 to-transparent"></div>
                    
                    {/* Title Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
                        <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-2 drop-shadow-lg">
                            Biomedical Engineering Services
                        </h3>
                        <div className="w-24 h-1 bg-gradient-to-r from-medical-teal-400 to-medical-green-400 rounded-full"></div>
                    </div>
                </div>

                {/* Content Section */}
                <div className="p-8 md:p-12 bg-gradient-to-b from-white to-gray-50">
                    <div className="space-y-6 text-gray-700 leading-relaxed">
                        {description.split('\n\n').map((paragraph, index) => (
                            <motion.p
                                key={index}
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                className="text-base md:text-lg mb-6"
                            >
                                {paragraph}
                            </motion.p>
                        ))}
                    </div>

                    {/* Services Highlights */}
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                        {[
                            'Feasibility Studies',
                            'Product Development',
                            'Regulatory Compliance',
                            'Testing & Manufacturing',
                            'Medical Device Design',
                            'Consulting Services'
                        ].map((service, index) => (
                            <motion.div
                                key={service}
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.3, delay: index * 0.05 }}
                                className="p-4 bg-gradient-to-br from-medical-blue-50 to-medical-teal-50 rounded-xl border border-medical-blue-200 text-center"
                            >
                                <span className="text-sm font-semibold text-medical-blue-700">{service}</span>
                            </motion.div>
                        ))}
                                    </div>

                    {/* CTA Button */}
                    <div className="mt-8">
                        <button
                            onClick={handleGetinTouch}
                            className="px-10 py-4 bg-gradient-to-r from-medical-blue-600 to-medical-blue-700 text-white font-bold rounded-xl hover:from-medical-blue-700 hover:to-medical-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] text-base ring-2 ring-medical-blue-200 hover:ring-medical-blue-300"
                        >
                            Request Quote
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}
